import React from 'react';
import { Link } from 'react-router-dom';
import { tilesFromSummary } from './outstandingTilesModel';

/** 10/23 (Josh): "tell me in boxes, just like the home page — what is outstanding". Each tile is a shortcut. */
export default function OutstandingTiles({ summary, loading }) {
  const tiles = tilesFromSummary(summary);
  if (loading && !summary) return <div className="text-sm text-slate-400">Loading what is outstanding…</div>;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3" data-testid="synd-outstanding-tiles">
      {tiles.map((t) => {
        const accent = t.good ? 'text-emerald-700' : t.warn ? 'text-red-600' : 'text-slate-900';
        const inner = (
          <div className="rounded-lg border border-slate-200 bg-white p-3 h-full hover:border-blue-400 hover:shadow-sm transition" data-testid={`synd-tile-${t.key}`}>
            <p className={`text-2xl font-bold ${accent}`}>{t.value}</p>
            <p className="text-xs uppercase tracking-wide text-slate-500 mt-1">{t.label}</p>
            {t.sub && <p className="text-xs text-slate-400 mt-0.5">{t.sub}</p>}
          </div>
        );
        return t.to.startsWith('#')
          ? <a key={t.key} href={t.to}>{inner}</a>
          : <Link key={t.key} to={t.to}>{inner}</Link>;
      })}
    </div>
  );
}
